import { render, staticRenderFns } from "./HomeMainBlock.vue?vue&type=template&id=44364e4b&scoped=true&"
import script from "./HomeMainBlock.vue?vue&type=script&lang=js&"
export * from "./HomeMainBlock.vue?vue&type=script&lang=js&"
import style0 from "./HomeMainBlock.vue?vue&type=style&index=0&id=44364e4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44364e4b",
  null
  
)

export default component.exports